import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Grid } from '@material-ui/core'

import { Children, DeleteChildModal, Header, InfoModal } from 'components'

import Circle from 'components/Circle'
import { IChild } from 'data/child'
import { isEducator } from 'services/user'
import { IPupil } from 'types/database/users/user/pupils'
import { _route } from '../../routes/config'

export interface IRightSideProps {
  key: string
  label: string
  onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

interface INativeProps {
  childrenList: IChild[]
  loading: boolean
  openDetails: any
  user: any
  deletePatient: (id: string) => void
  childAddClicked: () => void
}

export interface IProps extends INativeProps, RouteComponentProps {}

interface IState {
  modalOpen: boolean
  childToDeleteId: string
  isInfoModalOpen: boolean
  metaInfo?: IPupil
}

class Content extends React.PureComponent<IProps, IState> {
  state: IState = {
    modalOpen: false,
    childToDeleteId: '',
    isInfoModalOpen: false
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  setModalOpen = (modalOpen: boolean) => this.setState({ modalOpen })

  openInfoModal = (event, metaInfo: IPupil) => {
    event.stopPropagation()
    this.setState({ metaInfo }, () => this.setActiveInfoModal(true))
  }

  setActiveInfoModal = (status: boolean) => {
    this.setState({ isInfoModalOpen: status })
  }

  render() {
    const {
      childrenList,
      loading,
      openDetails,
      deletePatient,
      user
    } = this.props
    const { childToDeleteId, modalOpen, isInfoModalOpen, metaInfo } = this.state

    return (
      <>
        <Grid
          container={true}
          direction="column"
          justify="flex-start"
          alignItems="center"
          className="children-list-wrapper"
        >
          <Header
            title={isEducator(user?.role) ? 'My Pupils' : 'My Children'}
            oneRow={true}
            smallHeader={true}
            type="color"
            disableBackButton={true}
            defaultRightSide={true}
          />
          <div className="children-wrapper">
            {loading ? (
              <Circle />
            ) : (
              <div
                className={`children-list mobile-container ${
                  childrenList.length === 0
                    ? 'empty'
                    : childrenList.length === 1 && isEducator(user?.role)
                    ? 'one-child'
                    : 'no-empty'
                }`}
              >
                {childrenList &&
                  childrenList.map((item, i) => (
                    <Children
                      onClick={() => openDetails(item)}
                      key={i}
                      childrenAge={item.childrenAge}
                      childrenName={item.childrenName}
                      childrenPhoto={item.childrenPhoto}
                      childrenGender={item.childrenGender}
                      hasInfo={item.metaInfo !== undefined}
                      onDelete={() =>
                        this.setState({
                          modalOpen: true,
                          childToDeleteId: item.patientId || ''
                        })
                      }
                      openInfoModal={event =>
                        this.openInfoModal(event, item.metaInfo)
                      }
                    />
                  ))}
                {!isEducator(user?.role) && (
                  <Children
                    onClick={this.props.childAddClicked}
                    childrenName="Add Child"
                    childrenPhoto={require('../../assets/img/addChild.svg')}
                    className="add-child-card"
                    childrenGender=""
                  />
                )}
                {metaInfo && (
                  <InfoModal
                    open={isInfoModalOpen}
                    setActive={this.setActiveInfoModal}
                    metaInfo={metaInfo}
                  />
                )}
              </div>
            )}
          </div>
          <DeleteChildModal
            role={user?.role}
            onAgree={() => {
              deletePatient(childToDeleteId)
            }}
            open={!!childToDeleteId && modalOpen}
            setOpen={this.setModalOpen}
          />
        </Grid>
      </>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/ChildrenList/content.tsx